import { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Trash } from "@phosphor-icons/react";

export default function AdminAnnouncements() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ title: "", body: "", is_active: true });

  const load = async () => { const { data } = await api.get("/announcements"); setItems(data); };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/announcements", form);
      setForm({ title: "", body: "", is_active: true });
      toast.success("Posted");
      load();
    } catch (e2) { toast.error(formatApiError(e2)); }
  };
  const del = async (a) => { if (!confirm("Delete?")) return; await api.delete(`/admin/announcements/${a.id}`); load(); };

  return (
    <AdminLayout>
      <h1 className="text-3xl font-black tracking-tighter text-slate-900 dark:text-white mb-5" style={{ fontFamily: "'Cabinet Grotesk', system-ui, sans-serif" }}>Announcements</h1>
      <form onSubmit={submit} className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-5 mb-5 space-y-3">
        <input data-testid="ann-title-input" required placeholder="Title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 px-3 py-2 text-slate-900 dark:text-slate-100" />
        <textarea data-testid="ann-body-input" required rows="3" placeholder="Message to users…" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} className="w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 px-3 py-2 text-slate-900 dark:text-slate-100" />
        <label className="flex items-center gap-2"><input type="checkbox" checked={form.is_active} onChange={(e) => setForm({ ...form, is_active: e.target.checked })} /> Active</label>
        <button data-testid="ann-post-btn" className="rounded-full bg-blue-700 hover:bg-blue-800 text-white font-bold px-5 py-2 transition-colors duration-200">Post announcement</button>
      </form>
      <div className="space-y-3">
        {items.map((a) => (
          <div key={a.id} data-testid={`ann-${a.id}`} className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-4 flex items-start justify-between gap-3">
            <div>
              <div className="font-bold text-slate-900 dark:text-white">{a.title}</div>
              <div className="text-sm text-slate-600 dark:text-slate-300">{a.body}</div>
              <div className="text-xs text-slate-400 mt-1">{new Date(a.created_at).toLocaleString()}</div>
            </div>
            <button data-testid={`ann-del-${a.id}`} onClick={() => del(a)} className="text-red-600 hover:bg-red-50 dark:hover:bg-red-500/20 h-9 w-9 rounded-full inline-flex items-center justify-center"><Trash size={16} weight="bold" /></button>
          </div>
        ))}
      </div>
    </AdminLayout>
  );
}
